(function () {
  'use strict';

  var STORAGE_KEY = 'betonlife:selected-colour';

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function normaliseHex(value) {
    var hex = String(value || '').trim();
    return /^#[0-9a-f]{6}$/i.test(hex) ? hex : '#d8d4cf';
  }

  function normaliseColours(payload, system) {
    var rows = payload && Array.isArray(payload.colours) ? payload.colours : [];
    return rows.map(function (row, index) {
      return {
        system: system,
        label: system === 'ncs' ? 'NCS' : 'RAL Classic',
        code: String(row.code || '').trim(),
        name: String(row.name || '').trim(),
        family: String(row.family || 'Overig').trim(),
        hex: normaliseHex(row.hex),
        position: index
      };
    }).filter(function (row) { return row.code; });
  }

  function loadJson(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (response) {
      if (!response.ok) throw new Error('Kleurdata kon niet worden geladen (' + response.status + ').');
      return response.json();
    });
  }

  function canonicalCode(value) {
    var code = String(value || '').trim().replace(/\s+/g, ' ').toUpperCase();
    if (/^S\s+\d/.test(code)) code = 'NCS ' + code;
    return code;
  }

  function deriveSystem(value) {
    var code = canonicalCode(value);
    if (/^RAL\s/.test(code)) return 'RAL Classic';
    if (/^NCS\s/.test(code)) return 'NCS';
    return code ? 'Eigen invoer' : '';
  }

  function readStoredColour() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var colour = raw ? JSON.parse(raw) : null;
      return colour && colour.code && !colour.demo ? colour : null;
    } catch (error) {
      return null;
    }
  }

  function storeColour(colour) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(colour));
    } catch (error) {
      // De productkeuze blijft werken wanneer browseropslag is geblokkeerd.
    }
  }

  function initProductColour(root) {
    if (!root || root.dataset.blPcInitialised === 'true') return;
    root.dataset.blPcInitialised = 'true';

    var input = root.querySelector('[data-bl-pc-input]');
    var systemInput = root.querySelector('[data-bl-pc-system]');
    var help = root.querySelector('[data-bl-pc-help]');
    var openButton = root.querySelector('[data-bl-pc-open]');
    var changeButton = root.querySelector('[data-bl-pc-change]');
    var selectedBox = root.querySelector('[data-bl-pc-selected]');
    var selectedSwatch = root.querySelector('[data-bl-pc-selected-swatch]');
    var selectedCode = root.querySelector('[data-bl-pc-selected-code]');
    var selectedName = root.querySelector('[data-bl-pc-selected-name]');
    var modal = root.querySelector('[data-bl-pc-modal]');
    var dialog = root.querySelector('[role="dialog"]');
    var app = root.querySelector('[data-bl-pc-app]');
    var closeButtons = Array.prototype.slice.call(root.querySelectorAll('[data-bl-pc-close]'));
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-bl-pc-tab]'));
    var search = root.querySelector('[data-bl-pc-search]');
    var family = root.querySelector('[data-bl-pc-family]');
    var results = root.querySelector('[data-bl-pc-results]');
    var clearButton = root.querySelector('[data-bl-pc-clear]');
    var grid = root.querySelector('[data-bl-pc-grid]');
    var empty = root.querySelector('[data-bl-pc-empty]');
    var loadButton = root.querySelector('[data-bl-pc-load]');
    var pendingBox = root.querySelector('[data-bl-pc-pending]');
    var pendingSwatch = root.querySelector('[data-bl-pc-pending-swatch]');
    var pendingCode = root.querySelector('[data-bl-pc-pending-code]');
    var pendingName = root.querySelector('[data-bl-pc-pending-name]');
    var chooseHelp = root.querySelector('[data-bl-pc-choose-help]');
    var confirmButton = root.querySelector('[data-bl-pc-confirm]');
    var pageSize = Math.max(12, Number(root.dataset.pageSize) || 48);
    var lastFocused = null;
    var applyingColour = false;

    if (!input || !modal || !grid) return;

    var state = {
      system: 'ral',
      query: '',
      family: 'all',
      visible: pageSize,
      data: { ral: [], ncs: [] },
      loaded: false,
      loading: null,
      error: null,
      selected: null,
      pending: null
    };

    function currentRows() {
      return state.data[state.system] || [];
    }

    function filteredRows() {
      var query = state.query.toLocaleLowerCase('nl');
      return currentRows().filter(function (colour) {
        var familyMatch = state.family === 'all' || colour.family === state.family;
        var text = (colour.code + ' ' + colour.name + ' ' + colour.family).toLocaleLowerCase('nl');
        return familyMatch && (!query || text.indexOf(query) !== -1);
      });
    }

    function updateFamilyOptions() {
      var values = currentRows().map(function (colour) { return colour.family; })
        .filter(function (value, index, array) { return value && array.indexOf(value) === index; })
        .sort(function (a, b) { return a.localeCompare(b, 'nl'); });

      family.innerHTML = '<option value="all">Alle kleuren</option>' + values.map(function (value) {
        return '<option value="' + escapeHtml(value) + '">' + escapeHtml(value) + '</option>';
      }).join('');

      if (values.indexOf(state.family) === -1) state.family = 'all';
      family.value = state.family;
    }

    function cardHtml(colour) {
      var isPending = state.pending && state.pending.code === colour.code && state.pending.system === colour.system;
      return (
        '<button class="bl-product-colour__card' + (isPending ? ' is-pending' : '') + '" type="button"' +
          ' style="--bl-pc-swatch:' + escapeHtml(colour.hex) + '"' +
          ' data-bl-pc-code="' + escapeHtml(colour.code) + '"' +
          ' aria-pressed="' + (isPending ? 'true' : 'false') + '"' +
          ' aria-label="Selecteer ' + escapeHtml(colour.code + (colour.name ? ', ' + colour.name : '')) + '">' +
          '<span class="bl-product-colour__card-swatch" aria-hidden="true"></span>' +
          '<span class="bl-product-colour__card-copy">' +
            '<span class="bl-product-colour__card-code">' + escapeHtml(colour.code) + '</span>' +
            (colour.name ? '<span class="bl-product-colour__card-name">' + escapeHtml(colour.name) + '</span>' : '') +
          '</span>' +
        '</button>'
      );
    }

    function render() {
      if (!state.loaded) return;

      var rows = filteredRows();
      var visibleRows = rows.slice(0, state.visible);

      grid.innerHTML = visibleRows.map(cardHtml).join('');
      grid.hidden = rows.length === 0;
      empty.hidden = rows.length !== 0;
      loadButton.hidden = rows.length === 0 || visibleRows.length >= rows.length;
      clearButton.hidden = !state.query && state.family === 'all';
      results.textContent = state.error
        ? state.error
        : rows.length + (rows.length === 1 ? ' kleur' : ' kleuren');
    }

    function updatePending() {
      var colour = state.pending;
      pendingBox.hidden = !colour;
      chooseHelp.hidden = Boolean(colour);
      confirmButton.disabled = !colour;

      if (!colour) return;
      pendingSwatch.style.setProperty('--bl-pc-swatch', colour.hex);
      pendingCode.textContent = colour.code;
      pendingName.textContent = colour.name || colour.label;
    }

    function setPending(colour) {
      state.pending = colour;
      updatePending();
      render();
    }

    function setSystem(system) {
      if (system !== 'ral' && system !== 'ncs') return;
      state.system = system;
      state.query = '';
      state.family = 'all';
      state.visible = pageSize;
      search.value = '';

      tabs.forEach(function (tab) {
        var active = tab.dataset.blPcTab === system;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', String(active));
      });

      if (state.loaded) {
        updateFamilyOptions();
        render();
      }
    }

    function updateSystemProperty(value) {
      var system = deriveSystem(value);
      systemInput.value = system;
      systemInput.disabled = !system;
    }

    function showSelected(colour) {
      selectedBox.hidden = false;
      selectedSwatch.style.setProperty('--bl-pc-swatch', colour.hex);
      selectedCode.textContent = colour.code;
      selectedName.textContent = colour.name || colour.label || deriveSystem(colour.code);
    }

    function hideSelected() {
      selectedBox.hidden = true;
      selectedSwatch.style.removeProperty('--bl-pc-swatch');
      selectedCode.textContent = '';
      selectedName.textContent = '';
    }

    function applyColour(colour, persist) {
      if (!colour || !colour.code) return;

      state.selected = {
        system: colour.system || (deriveSystem(colour.code) === 'NCS' ? 'ncs' : 'ral'),
        label: colour.label || deriveSystem(colour.code),
        code: canonicalCode(colour.code),
        name: colour.name || '',
        hex: normaliseHex(colour.hex),
        demo: false
      };

      input.value = state.selected.code;
      input.removeAttribute('aria-invalid');
      input.setCustomValidity('');
      updateSystemProperty(state.selected.code);
      showSelected(state.selected);
      help.textContent = 'De gekozen kleur staat klaar en wordt aan uw bestelling toegevoegd.';

      applyingColour = true;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      applyingColour = false;

      if (persist !== false) storeColour(state.selected);

      document.dispatchEvent(new CustomEvent('betonlife:colour-selected', {
        detail: state.selected
      }));
    }

    function findExactColour(value) {
      var code = canonicalCode(value);
      var all = state.data.ral.concat(state.data.ncs);
      return all.find(function (colour) { return canonicalCode(colour.code) === code; }) || null;
    }

    function resolveManualValue() {
      if (applyingColour) return;
      var value = String(input.value || '').trim();
      if (!value) return;

      if (state.loaded) {
        var exact = findExactColour(value);
        if (exact) {
          applyColour(exact, false);
          return;
        }
      }

      input.value = canonicalCode(value);
      updateSystemProperty(input.value);
    }

    function handleManualInput() {
      var value = String(input.value || '').trim();
      input.removeAttribute('aria-invalid');
      input.setCustomValidity('');
      updateSystemProperty(value);

      if (!value) {
        state.selected = null;
        hideSelected();
        help.textContent = 'Dit veld wordt automatisch ingevuld wanneer u een kleur uit de kleurenwaaier kiest.';
        return;
      }

      if (!state.selected || canonicalCode(value) !== canonicalCode(state.selected.code)) {
        state.selected = null;
        hideSelected();
        help.textContent = 'Handmatig ingevulde kleurcode. Controleer de schrijfwijze zorgvuldig.';
      }
    }

    function ensureData() {
      if (state.loaded) return Promise.resolve();
      if (state.loading) return state.loading;

      state.error = null;
      app.setAttribute('aria-busy', 'true');
      results.textContent = 'Kleuren worden geladen…';

      state.loading = Promise.all([
        loadJson(root.dataset.ralUrl),
        loadJson(root.dataset.ncsUrl)
      ]).then(function (payloads) {
        state.data.ral = normaliseColours(payloads[0], 'ral');
        state.data.ncs = normaliseColours(payloads[1], 'ncs');
        state.loaded = true;
        state.loading = null;

        ['ral', 'ncs'].forEach(function (system) {
          var count = root.querySelector('[data-bl-pc-count="' + system + '"]');
          if (count) count.textContent = state.data[system].length + ' kleuren';
        });

        app.setAttribute('aria-busy', 'false');
        updateFamilyOptions();
        resolveManualValue();
        render();
      }).catch(function (error) {
        state.error = error.message || 'De kleurdata kon niet worden geladen.';
        state.loading = null;
        app.setAttribute('aria-busy', 'false');
        results.textContent = state.error;
        grid.hidden = true;
        empty.hidden = false;
      });

      return state.loading;
    }

    function openModal() {
      lastFocused = document.activeElement;
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('bl-product-colour-modal-open');

      if (state.selected && (state.selected.system === 'ral' || state.selected.system === 'ncs')) {
        state.pending = state.selected;
        setSystem(state.selected.system);
      } else {
        state.pending = null;
      }

      updatePending();
      ensureData();

      window.setTimeout(function () {
        var close = root.querySelector('.bl-product-colour__close');
        if (close) close.focus();
      }, 0);
    }

    function closeModal() {
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('bl-product-colour-modal-open');
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }

    function clearFilters() {
      state.query = '';
      state.family = 'all';
      state.visible = pageSize;
      search.value = '';
      family.value = 'all';
      render();
      search.focus();
    }

    function trapFocus(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeModal();
        return;
      }

      if (event.key !== 'Tab') return;
      var focusable = Array.prototype.slice.call(dialog.querySelectorAll('button:not([disabled]), input:not([disabled]), select:not([disabled]), [href]'))
        .filter(function (element) { return element.offsetParent !== null; });
      if (!focusable.length) return;

      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    openButton.addEventListener('click', openModal);
    if (changeButton) changeButton.addEventListener('click', openModal);
    closeButtons.forEach(function (button) { button.addEventListener('click', closeModal); });
    modal.addEventListener('keydown', trapFocus);

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () { setSystem(tab.dataset.blPcTab); });
    });

    search.addEventListener('input', function () {
      state.query = search.value.trim();
      state.visible = pageSize;
      render();
    });

    family.addEventListener('change', function () {
      state.family = family.value;
      state.visible = pageSize;
      render();
    });

    clearButton.addEventListener('click', clearFilters);

    loadButton.addEventListener('click', function () {
      state.visible += pageSize;
      render();
    });

    grid.addEventListener('click', function (event) {
      var button = event.target.closest('[data-bl-pc-code]');
      if (!button) return;
      var code = button.dataset.blPcCode;
      var colour = currentRows().find(function (item) { return item.code === code; });
      if (colour) setPending(colour);
    });

    confirmButton.addEventListener('click', function () {
      if (!state.pending) return;
      applyColour(state.pending, true);
      closeModal();
    });

    input.addEventListener('input', handleManualInput);
    input.addEventListener('change', resolveManualValue);
    input.addEventListener('blur', resolveManualValue);
    input.addEventListener('invalid', function () {
      input.setAttribute('aria-invalid', 'true');
      help.textContent = 'Kies een kleur via de kleurenwaaier of vul een kleurcode in.';
    });
    if (input.form) input.form.addEventListener('submit', resolveManualValue);

    var params = new URLSearchParams(window.location.search);
    var queryCode = params.get('kleur');
    var querySystem = params.get('kleurstelsel');
    var stored = readStoredColour();

    if (queryCode) {
      if (stored && canonicalCode(stored.code) === canonicalCode(queryCode)) {
        applyColour(stored, false);
      } else {
        input.value = canonicalCode(queryCode);
        updateSystemProperty(querySystem || input.value);
        help.textContent = 'Kleurcode overgenomen uit de kleurenpagina. Controleer uw keuze vóór het bestellen.';
      }
    } else if (input.value) {
      updateSystemProperty(input.value);
    } else if (stored) {
      applyColour(stored, false);
    }
  }

  function initAll(scope) {
    Array.prototype.slice.call((scope || document).querySelectorAll('[data-bl-product-colour]')).forEach(initProductColour);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
